import axios from 'axios'

import { loginLoading, loginError, loginSuccess, logoutLoading, logoutError, logoutSuccess } from '../slices/auth'
import { clearStateAccount } from '../slices/account'
import { clearStateCharacter } from '../slices/character'
import { clearStateEvent } from '../slices/event'

export const register = async (data, navigate, toast, error) => {
	try {
		const res = await axios.post('/user/auth/register/', data)
		if (res) {
			toast.success('Đăng kí tài khoản thành công, bạn có thể tiến hành đăng nhập để quản lí tài khoản của mình')
			navigate('/login')
		}
	} catch (err) {
		console.log(err)
		error('afterSubmit', {
			...err.response.data.message,
			message: err.response.data.message
		})
	}
}

export const login = async (data, dispatch, error) => {
	dispatch(loginLoading())
	try {
		const res = await axios.post('/user/auth/login/', data)
		dispatch(loginSuccess(res.data))
	} catch (err) {
		console.log(err)
		dispatch(loginError())
		error('afterSubmit', {
			...err.response.data.message,
			message: err.response.data.message
		})
	}
}

export const logout = async (dispatch) => {
	dispatch(logoutLoading())
	try {
		await axios.post('/user/auth/logout/')
		dispatch(logoutSuccess())
		dispatch(clearStateAccount())
		dispatch(clearStateCharacter())
		dispatch(clearStateEvent())
	} catch (err) {
		console.log(err)
		dispatch(logoutError())
	}
}

export const forgotPassword = async (data, error) => {
	try {
		const res = await axios.post('/user/auth/forgot-password/', data)
		if (res) {
			error('afterSubmit', {
				...res.data.message,
				message: res.data.message,
				type: 'success'
			})
		}
	} catch (err) {
		console.log(err)
		error('afterSubmit', {
			...err.response.data.message,
			message: err.response.data.message,
			type: 'danger'
		})
	}
}

export const updatePassword = async (data, token, navigate, toast, error) => {
	try {
		const res = await axios.post(`/user/auth/update-password/${token}`, data)
		if (res) {
			toast.success(res.data.message)
			navigate('/login')
		}
	} catch (err) {
		console.log(err)
		error('afterSubmit', {
			...err.response.data.message,
			message: err.response.data.message
		})
	}
}
